import { Injectable } from "@angular/core";
import { MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { TravelReimbursementFormDataService } from "common/services/data-services/student/travel-reimbursement/travel-form-data.service";
import { TravelReimbursementModel } from "common/models/page-models/travel-reimbursement/travel-reimbursement-data.model";
import { TravelReimbursementMetaModel } from "common/models/page-models/travel-reimbursement/travel-reimbursement-form-meta.model";

@Injectable({
    providedIn: 'root'
})
export class TravelReimbursementFormWidgetService extends FormWidgetService<TravelReimbursementModel> {
    constructor(protected ds: TravelReimbursementFormDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new TravelReimbursementMetaModel();
        return meta.getMetaModel();
    }

    // override prepareMetaModel(dataModel: TravelReimbursementModel, metaModel: TravelReimbursementMetaModel, routeData: WidgetModel, event: any = null): Promise<TravelReimbursementMetaModel> {
    //     return new Promise<TravelReimbursementMetaModel>((resolve, reject) => {
    //         console.log(event)
    //         if (event !== null && event.field_Name === 'travelStartDate'){
    //             metaModel.properties.travelEndDate.propminDate = dataModel.travelStartDate;
    //         }

    //         if(event === null) {
    //             console.log(dataModel)
    //             metaModel.properties.travelEndDate.propminDate = dataModel.travelStartDate;
    //         }
    //         // metaModel.pageTitle = dataModel.id !== 0 ?  'Update Branch Category' : 'Add Branch Category';
    //         resolve(metaModel);
    //     });
    // }
}
